var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("app-imovel-area-permutada", {
        attrs: { imovel: _vm.cadastro.imovel }
      }),
      _c("app-imovel-area-interesse", {
        attrs: { imovel: _vm.cadastro.imovel }
      }),
      _vm.inputsExtraCadastro.imovel.escrituraDocumentoRegistro
        ? _c("app-documentos", {
            attrs: {
              maxSize: 25,
              "valid-extensions": ["doc", "docx", "jpeg", "jpg", "pdf", "png"],
              documentos: _vm.cadastro.imovel.documentos,
              tiposDocumentos: _vm.documentos,
              tiposDocumentosObrigatorios: _vm.documentosObrigatorio,
              observer: _vm.observer,
              aba: "Interessado"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ebdcbaf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ebdcbaf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/cadastros/para/permuta/components/Imovel.vue
// module id = null
// module chunks = 